// Utility function to generate timezone label with current GMT offset (DST-aware)
function getCurrentGMTOffsetLabel(timeZone: string): string {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone,
    timeZoneName: "shortOffset",
  });

  const parts = formatter.formatToParts(now);
  const offsetPart = parts.find(part => part.type === "timeZoneName");
  const gmtOffset = offsetPart ? offsetPart.value : "";

  const readableName = timeZone.replace(/_/g, " ").replace(/\//g, " - ");
  return `(${gmtOffset}) ${readableName}`;
}

// Timezone list using dynamic labels
export const timezones = [
  "Pacific/Pago_Pago",
  "Pacific/Honolulu",
  "America/Los_Angeles",
  "America/Tijuana",
  "America/Denver",
  "America/Phoenix",
  "America/Mazatlan",
  "America/Chicago",
  "America/Mexico_City",
  "America/Regina",
  "America/Guatemala",
  "America/Bogota",
  "America/New_York",
  "America/Lima",
  "America/Caracas",
  "America/Halifax",
  "America/Guyana",
  "America/La_Paz",
  "America/Argentina/Buenos_Aires",
  "America/Godthab",
  "America/Montevideo",
  "America/St_Johns",
  "America/Santiago",
  "America/Sao_Paulo",
  "Atlantic/South_Georgia",
  "Atlantic/Azores",
  "Atlantic/Cape_Verde",
  "Africa/Casablanca",
  "Europe/Dublin",
  "Europe/Lisbon",
  "Europe/London",
  "Africa/Monrovia",
  "Africa/Algiers",
  "Europe/Amsterdam",
  "Europe/Berlin",
  "Europe/Brussels",
  "Europe/Budapest",
  "Europe/Belgrade",
  "Europe/Prague",
  "Europe/Copenhagen",
  "Europe/Madrid",
  "Europe/Paris",
  "Europe/Rome",
  "Europe/Stockholm",
  "Europe/Vienna",
  "Europe/Warsaw",
  "Europe/Athens",
  "Europe/Bucharest",
  "Africa/Cairo",
  "Asia/Jerusalem",
  "Africa/Johannesburg",
  "Europe/Helsinki",
  "Europe/Kiev",
  "Europe/Kaliningrad",
  "Europe/Riga",
  "Europe/Sofia",
  "Europe/Tallinn",
  "Europe/Vilnius",
  "Europe/Istanbul",
  "Asia/Baghdad",
  "Africa/Nairobi",
  "Europe/Minsk",
  "Asia/Riyadh",
  "Europe/Moscow",
  "Asia/Tehran",
  "Asia/Baku",
  "Europe/Samara",
  "Asia/Tbilisi",
  "Asia/Yerevan",
  "Asia/Kabul",
  "Asia/Karachi",
  "Asia/Yekaterinburg",
  "Asia/Tashkent",
  "Asia/Calcutta",
  "Asia/Colombo",
  "Asia/Almaty",
  "Asia/Dhaka",
  "Asia/Rangoon",
  "Asia/Bangkok",
  "Asia/Jakarta",
  "Asia/Krasnoyarsk",
  "Asia/Shanghai",
  "Asia/Hong_Kong",
  "Asia/Kuala_Lumpur",
  "Asia/Irkutsk",
  "Asia/Singapore",
  "Asia/Taipei",
  "Asia/Ulaanbaatar",
  "Australia/Perth",
  "Asia/Yakutsk",
  "Asia/Seoul",
  "Asia/Tokyo",
  "Australia/Darwin",
  "Australia/Brisbane",
  "Pacific/Guam",
  "Asia/Magadan",
  "Asia/Vladivostok",
  "Pacific/Port_Moresby",
  "Australia/Adelaide",
  "Australia/Hobart",
  "Australia/Sydney",
  "Pacific/Guadalcanal",
  "Pacific/Noumea",
  "Pacific/Majuro",
  "Asia/Kamchatka",
  "Pacific/Auckland",
  "Pacific/Fakaofo",
  "Pacific/Fiji",
  "Pacific/Tongatapu",
  "Pacific/Apia"
].map((tz) => ({
  value: tz,
  label: getCurrentGMTOffsetLabel(tz)
}));
